import React from "react";

export const ReviewDisplayField = (props) => {
  const rowClassNames = props.rowClassNames ? props.rowClassNames : "";
  const valueClassNames = props.valueClassNames ? props.valueClassNames : "";

  // Use in specific situations when we need the column sizes to be adjusted
  const titleColumnSize = props.titleColumnSize ? props.titleColumnSize : "col-md-7";
  const valueColumnSize = props.valueColumnSize ? props.valueColumnSize : "col-md-5";

  return (
    <div className={"row mb-4 " + rowClassNames}>
      <div className={`${titleColumnSize} col-sm-12`}>{props.title}</div>
      <div className={`${valueColumnSize} col-2 bold text-end ` + valueClassNames} data-e2e-id={"reviewDetail-" + props.title}>
        {props.value}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/misc/review-display-field.component.js